class Module {
  constructor(quill, options = {}) {
    this.quill = quill;
    this.options = options;
  }
}
Module.DEFAULTS = {};


export default Module;



/** WEBPACK FOOTER **
 ** ./core/module.js
 **/